module.exports = __webpack_public_path__ + "static/checkset2-29f9e28d4b4b60bb005767598c3775a1.jpeg";